export default __webpack_public_path__ + "static/media/main_logo.2620b4cf.png";